import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Box from "@mui/material/Box";
/**
 * @todo Figure out how to handle this in production. Translate
 * @param props
 * @returns
 */
export function AttributeNotFound(props) {
    return (_jsx(Box, { sx: {
            my: 2,
        }, children: _jsxs(Alert, { severity: "warning", children: [_jsxs(AlertTitle, { children: ["Attribute not found ", props.attributeId] }), "The attribute for this component was not found"] }) }));
}
//# sourceMappingURL=AttributeNotFound.js.map